const TIMEZONE_MAP = {
    'EST': 'America/New_York',
    'EDT': 'America/New_York',
    'ET': 'America/New_York',
    'CST': 'America/Chicago',
    'CDT': 'America/Chicago',
    'CT': 'America/Chicago',
    'MST': 'America/Denver',
    'MDT': 'America/Denver',
    'MT': 'America/Denver',
    'PST': 'America/Los_Angeles',
    'PDT': 'America/Los_Angeles',
    'PT': 'America/Los_Angeles',
    'ARZ': 'America/Phoenix',
    'AZ': 'America/Phoenix',
    'MST-AZ': 'America/Phoenix',
    'AKST': 'America/Anchorage',
    'AKDT': 'America/Anchorage',
    'AKT': 'America/Anchorage',
    'HST': 'Pacific/Honolulu',
    'HT': 'Pacific/Honolulu',
    'HAST': 'Pacific/Honolulu',
    'AST': 'America/Halifax',
    'ADT': 'America/Halifax',
    'UTC': 'UTC',
    'GMT': 'UTC',
    'Z': 'UTC',
};
export const getIANATimezone = (timezoneAbbr) => {
    if (!timezoneAbbr)
        return 'UTC';
    const normalized = timezoneAbbr.toUpperCase().trim();
    if (normalized.includes('/')) {
        return timezoneAbbr;
    }
    return TIMEZONE_MAP[normalized] || 'UTC';
};
export const convertUtcToAccountLocal = (utcDateString, timezoneAbbr) => {
    if (!utcDateString)
        return utcDateString;
    try {
        const normalizedUtc = utcDateString.endsWith('Z') ? utcDateString : `${utcDateString}Z`;
        const utcDate = new Date(normalizedUtc);
        if (isNaN(utcDate.getTime())) {
            return utcDateString;
        }
        const ianaTimezone = getIANATimezone(timezoneAbbr);
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
        const parts = formatter.formatToParts(utcDate);
        const dateComponents = {};
        for (const part of parts) {
            if (part.type !== 'literal') {
                dateComponents[part.type] = part.value;
            }
        }
        const hour = dateComponents.hour === '24' ? '00' : dateComponents.hour;
        return `${dateComponents.year}-${dateComponents.month}-${dateComponents.day}T${hour}:${dateComponents.minute}:${dateComponents.second}`;
    }
    catch (error) {
        console.warn('Failed to convert UTC to account local time:', error);
        return utcDateString;
    }
};
export const getLocalDateComponents = (utcDateString, timezoneAbbr) => {
    if (!utcDateString)
        return null;
    try {
        const normalizedUtc = utcDateString.endsWith('Z') ? utcDateString : `${utcDateString}Z`;
        const utcDate = new Date(normalizedUtc);
        if (isNaN(utcDate.getTime())) {
            return null;
        }
        const ianaTimezone = getIANATimezone(timezoneAbbr);
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
        const parts = formatter.formatToParts(utcDate);
        const components = {};
        for (const part of parts) {
            if (part.type !== 'literal') {
                components[part.type] = parseInt(part.value, 10);
            }
        }
        return {
            year: components.year || 0,
            month: components.month || 0,
            day: components.day || 0,
            hour: components.hour || 0,
            minute: components.minute || 0,
            second: components.second || 0,
        };
    }
    catch (error) {
        console.warn('Failed to get local date components:', error);
        return null;
    }
};
class AccountTimezoneStore {
    constructor() {
        this.timezones = {};
    }
    static getInstance() {
        if (this.instance === null) {
            this.instance = new AccountTimezoneStore();
        }
        return this.instance;
    }
    set(accountId, timezone) {
        this.timezones[accountId] = timezone;
    }
    get(accountId) {
        return this.timezones[accountId];
    }
    setAll(timezones) {
        this.timezones = { ...this.timezones, ...timezones };
    }
    clear() {
        this.timezones = {};
    }
    getAll() {
        return { ...this.timezones };
    }
}
AccountTimezoneStore.instance = null;
export const setAccountTimezone = (accountId, timezone) => {
    AccountTimezoneStore.getInstance().set(accountId, timezone);
};
export const getAccountTimezone = (accountId) => {
    return AccountTimezoneStore.getInstance().get(accountId);
};
export const setAccountTimezones = (timezones) => {
    AccountTimezoneStore.getInstance().setAll(timezones);
};
export const clearAccountTimezones = () => {
    AccountTimezoneStore.getInstance().clear();
};
export const getAllAccountTimezones = () => {
    return AccountTimezoneStore.getInstance().getAll();
};
//# sourceMappingURL=timezoneUtils.js.map